import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get, debounce } from 'lodash';


class AddScrollHeight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.calculateChildrenHeight();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = debounce(() => this.calculateChildrenHeight(), 150)

  calculateChildrenHeight() {
    this.setState({
      height: get(this.el, 'children[0].clientHeight', 0),
    });
  }

  render() {
    return (
      <div
        ref={(el) => { this.el = el; }}
        style={{ height: this.state.height }}
      >
        {this.props.children}
      </div>
    );
  }
}
AddScrollHeight.propTypes = {
  children: PropTypes.element.isRequired,
};

export default AddScrollHeight;



// WEBPACK FOOTER //
// ./src/app/components/AddScrollHeight.jsx